<template>
  <SemesterModulesModal
      :is-open="isOpen"
      :semester="currentModalSemester"
      :without-preview="true"
      modal-name="DesiredSemesterModulesModal"
      icon-modal="travel_explore"
      :modal-title="modalTitle"
      modal-subtitle="Selected modules will be pinned to this semester."
      modal-class="medium-wide-modal"
      @close="closeModal"
  />
</template>

<script>
import SemesterModulesModal from "@/components/modals/SemesterModulesModal.vue";
import { mapState, mapMutations } from "vuex";

export default {
  name: "DesiredSemesterModulesModal",
  components: { SemesterModulesModal },
  computed: {
    ...mapState(["currentModal", "currentModalSemester", "schedule"]),
    isOpen() {
      return this.currentModal === "DesiredSemesterModulesModal";
    },
    semesterDescription() {
      const semesterSchedule = this.schedule[this.currentModalSemester];
      return semesterSchedule ? semesterSchedule.semesterDescription : null;
    },
    modalTitle() {
      return "Explore module options in the " + (this.semesterDescription?.toLowerCase() ?? "");
    }
  },
  methods: {
    ...mapMutations(["CLOSE_MODAL"]),
    closeModal() {
      this.CLOSE_MODAL();
    }
  }
};
</script>
